import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { Observable, shareReplay } from 'rxjs';

import { backendUrl } from './backend-url';

interface CsrfResponse {
  token: string;
  headerName: string;
}

@Injectable({ providedIn: 'root' })
export class CsrfService {
  private readonly http = inject(HttpClient);
  private token$ = this.createTokenStream();

  getToken$(): Observable<CsrfResponse> {
    return this.token$;
  }

  clear(): void {
    this.token$ = this.createTokenStream();
  }

  private createTokenStream(): Observable<CsrfResponse> {
    return this.http
      .get<CsrfResponse>(backendUrl('/csrf'))
      .pipe(shareReplay({ bufferSize: 1, refCount: false }));
  }
}
